import PropTypes from "prop-types";

import RewardIcon from "@/icons/RewardIcon";
import {
  possibleTokensNumberCss,
  possibleTokensTextCss,
  rewardIconCss,
} from "./PossibleTokens.style";

const propTypes = {
  tokens: PropTypes.number,
};

const PossibleTokens = ({ tokens }) => (
  <>
    <RewardIcon
      css={rewardIconCss}
      aria-hidden={false}
      aria-label="Tokens icon"
    />
    <span data-testId="tokensCount" css={possibleTokensNumberCss}>
      {tokens?.toLocaleString("en-US")}
    </span>
    <span data-testId="possibleTokensText" css={possibleTokensTextCss}>
      POSSIBLE TOKENS
    </span>
  </>
);

PossibleTokens.propTypes = propTypes;
export default PossibleTokens;
